import { render, staticRenderFns } from "./_aside.vue?vue&type=template&id=a32395a4"
import script from "./_aside.vue?vue&type=script&lang=js"
export * from "./_aside.vue?vue&type=script&lang=js"
import style0 from "./_aside.vue?vue&type=style&index=0&id=a32395a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports